import { get, post } from './../Config/config';


export const DeleteApI = {

    deletedata: (data) => post(data.url, { id: data.id }),

}
